export const ROUTES = {
    HOME_PAGE: 'HomePage',
};
